import type { MapMarker } from '../../models/MapModels';

/** Keep the opened referral visible even when nearby Points of Service cluster. */
export const shouldRenderMarkerOutsideCluster = (
  marker: Pick<MapMarker, 'id' | 'isReferral' | 'isCompetitorPreview'>,
  selectedId?: string,
  disableClustering = false,
): boolean => disableClustering || marker.isCompetitorPreview === true ||
  (marker.isReferral === true && marker.id === selectedId);
